export default {
    narrative: 'Narrative',
    discovery_report: 'Client Report',
    numbers_file_pdf: 'Numbers File',
    ct600_iris: 'CT600 (TaxCalc)',
    tax_computation_iris: 'Tax Computation',
    hmrc_form: 'HMRC Additional Information Form',
    hmrc_form_merge_scheme: 'Additional Information for HMRC (Merged Scheme)',
    r_d_report: 'Your R&D Claim Explained'
}
